import clockIcon from 'assets/images/icons/clock.svg';

export const dashboardsSetupTabsList = [
  {
    id: 1,
    title: 'tabs_form_meta_and_sql',
    value: 'form_meta_and_sql',
    breadcrumbValue: {
      icon: clockIcon,
      items: ['sidebar_dashboard_setup', 'tabs_form_meta_and_sql'],
    },
  },
  {
    id: 2,
    title: 'tabs_forms_structure',
    value: 'forms_structure',
    breadcrumbValue: {
      icon: clockIcon,
      items: ['sidebar_dashboard_setup', 'tabs_forms_structure'],
    },
  },
];

export const formsStructureHeaderList = [
  {
    name: 'form_id',
    displayName: 'table_header_form_id',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'form_id',
  },
  {
    name: 'form_title',
    displayName: 'table_header_form_title',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'form_title',
  },
  {
    name: 'field_title',
    displayName: 'table_header_fields_title',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'field_title',
  },
  {
    name: 'field_id',
    displayName: 'table_header_fields_id',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'field_id',
  },
  {
    name: 'required',
    displayName: 'table_header_required',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'required',
    populateFunc: 'boolToUpperCaseText',
  },
  {
    name: 'hidden',
    displayName: 'table_header_hidden',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'hidden',
    populateFunc: 'boolToUpperCaseText',
  },
  {
    name: 'hint_text',
    displayName: 'table_header_hint_text',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'hint_text',
  },
  {
    name: 'scoring_field',
    displayName: 'table_header_scoring',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'scoring_field',
    populateFunc: 'boolToUpperCaseText',
  },
  {
    name: 'field_type',
    displayName: 'table_header_field_type',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'field_type',
  },
  {
    name: 'section',
    displayName: 'table_header_section',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'section_title',
  },
  {
    name: 'topics',
    displayName: 'table_header_topic',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: null,
    populateFunc: 'populateSetSelection',
    sendRowWithKeyValue: true,
    callbackFunc: 'setsDetail',
    setType: 'topic',
  },
];
export const formsMetaSQLHeaderList = [
  {
    name: 'sr',
    mandatory: true,
    isSelected: true,
    displayName: '#',
    isFilterAble: false,
    type: 'text',
    associatedKey: 'indexed',
  },
  {
    name: 'formTitle',
    displayName: 'table_header_form_name',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'formTitle',
  },
  {
    name: 'status',
    displayName: 'table_header_form_status',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    populateFunc: 'populateFormStatus',
  },
  {
    name: 'createdAt',
    displayName: 'table_header_created_at',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'createdAt',
    populateFunc: 'populateFormDateTime',
  },
  {
    name: 'createdBy',
    displayName: 'table_header_created_by',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'createdBy',
    populateFunc: 'populateUserNameWithInitials',
  },
  {
    name: 'updatedAt',
    displayName: 'table_header_last_updated',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'updatedAt',
    populateFunc: 'populateFormDateTime',
  },
  {
    name: 'formEntries',
    displayName: 'table_header_form_entries',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'formEntries',
  },
  {
    name: 'dbName',
    displayName: 'table_header_db_name',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    populateFunc: 'populateDashboardsSetupDBName',
    filterKey: 'dbName',
    callbackFunc: 'setsDetail',
  },
  {
    name: 'dbConnection',
    displayName: 'table_header_data_connection',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    populateFunc: 'populateDashboardsSetupDBConnectionCheckBox',
    filterKey: 'dbConnection',
    callbackFunc: 'setsDetail',
  },
];

export const demoFormsStructureList = [
  {
    _id: '690075e902971d848a36e52f',
    elementGlobalId: '690075e902971d848a36e52f',
    '68ee2dddf8b51090ebfe473d': '65a65e729e61267867e22a0c',
    referenceNumber: 8,
  },
  {
    _id: '690075e902971d848a3uh7634',
    elementGlobalId: '690075e902971d848a3uh7634',
    '68ee2dddf8b51090ebfe473d': null,
    referenceNumber: 8,
  },
];

export const createUpdateRecordStructure = (
  prevObj,
  form_id,
  sql_column,
  field_id = null,
  type,
  setId,
  optionId,
  optionValue,
) => {
  // Initialize the outer structure if not already present
  if (!prevObj[form_id]) {
    prevObj[form_id] = {};
  }
  if (!prevObj[form_id][sql_column]) {
    prevObj[form_id][sql_column] = {};
  }

  // Initialize the field structure if field_id is provided or if it's 'none'
  let fieldKey = field_id === null ? 'none' : field_id;

  if (!prevObj[form_id][sql_column][fieldKey]) {
    prevObj[form_id][sql_column][fieldKey] = {};
  }

  // Add the provided values to the structure
  prevObj[form_id][sql_column][fieldKey] = {
    optionId: optionId,
    optionValue: optionValue,
    type: type,
    setId: setId,
  };
  return prevObj;
};
